import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/login/login')
    }, {
      path: '/AdminHome',
      name: 'AdminHome',
      component: () => import('@/views/home/AdminHome')
    },
    {
      path: '/AliPay',
      name: 'AliPay',
      component: () => import('@/component/AliPay')
    },
    {
      path: '/AfterAliPay',
      name: 'AfterAliPay',
      component: () => import('@/component/AfterAliPay')
    },
    {
      path: '/bigScreen',
      name: 'bigScreen',
      component: () => import('@/views/statistics/allData')
    }
  ]
})



// var router = new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'login',
//       component: () => import ('./views/login/login.vue'),
//       hidden: true
//     },
//     // {
//     //   path: '/home',      
//     //   component: layout,
//     //   redirect: '/home/allData',
//     //   meta: {title: '首页', icon: '#se-icon-data'},
//     //   children: [
//     //     {
//     //       path: 'allData',
//     //       name: 'home',
//     //       component: ()=> import('./views/allData.vue'),
//     //       meta: {title: '数据汇总'}
//     //     }
//     //   ]
//     // },
//     {
//       path: '/home',      
//       component: layout,
//       // redirect: 'home/allData',
//       meta: {title: '首页', icon: '#se-icon-home'},
//       children: [
//         {
//           path: 'dataStatistics',
//           component: ()=> import('./views/home/dataStatistics.vue'),
//           meta: {title: '数据统计'}
//         },
//         {
//           path: 'dataSummary',
//           component: ()=> import('./views/home/dataSummary.vue'),
//           meta: {title: '数据汇总'}
//         },
//         {
//           path: 'myAccount',
//           component: ()=> import('./views/home/myAccount.vue'),
//           meta: {title: '我的账户'}
//         }
//       ]
//     },
//     {
//       path: '/order',
//       component: layout,
//       redirect: 'order/precharge',
//       meta: {title: '订单管理', icon: '#se-icon-order'},
//       children: [
//         {
//           path: 'precharge',
//           component: ()=> import('./views/order/prechargeMgt.vue'),
//           meta: {title: '预充值管理'}
//         },
//         {
//           path: 'agentOrder',
//           component: ()=> import('./views/order/agentOrder.vue'),
//           meta: {title: '系统订单管理 '}
//         },
//         {
//           path: 'checkBalance',
//           component: ()=> import('./views/order/checkBalance.vue'),
//           meta: {title: '余额查询'}
//         },
//         {
//           path: 'wxOrder',
//           component: ()=> import('./views/order/wxOrder.vue'),
//           meta: {title: '微信订单'}
//         },
//         {
//           path: 'orderMgt',
//           component: ()=> import('./views/order/orderMgt.vue'),
//           meta: {title: '订单管理'}
//         },
//         {
//           path: 'refundOrder',
//           component: ()=> import('./views/order/refundOrder.vue'),
//           meta: {title: '退款订单'}
//         },
//         {
//           path: 'prechargeOrder',
//           component: ()=> import('./views/order/prechargeOrder.vue'),
//           meta: {title: '预充值订单'}
//         }
//       ]
//     },
//     {
//       path: '/simMgt',
//       component: layout,
//       meta: {title: 'SIM卡管理', icon: '#se-icon-sim'},
//       children: [
//         {
//           path: 'cardImport',
//           component: ()=> import('./views/sim/cardImport.vue'),
//           meta: {title: '卡片导入'}
//         },
//         {
//           path: 'cardMgt',
//           component: ()=> import('./views/sim/cardMgt.vue'),
//           meta: {title: '卡片管理'}
//         },
//         {
//           path: 'cardDetails',
//           component: ()=> import('./views/sim/cardDetails.vue'),
//           meta: {title: '卡片详情'}
//         },
//         {
//           path: 'cardDistribut',
//           component: ()=> import('./views/sim/cardDistribut.vue'),
//           meta: {title: '卡片分销'}
//         },
//         {
//           path: 'cardList',
//           component: ()=> import('./views/sim/cardList.vue'),
//           meta: {title: '卡片列表'}
//         },
//         {
//           path: 'cardInfo',
//           component: ()=> import('./views/sim/cardInfo.vue'),
//           meta: {title: '卡片信息'}
//         },
//         {
//           path: 'batchOperate',
//           component: ()=> import('./views/sim/batchOperate.vue'),
//           meta: {title: '批量操作'}
//         },
//         {
//           path: 'bgdRecharge',
//           component: ()=> import('./views/sim/bgdRecharge.vue'),
//           meta: {title: '后台充值'}
//         },
//         {
//           path: 'batchRefund',
//           component: ()=> import('./views/sim/batchRefund.vue'),
//           meta: {title: '批量退款'}
//         },
//         {
//           path: 'batchRecharge',
//           component: ()=> import('./views/sim/batchRecharge.vue'),
//           meta: {title: '批量充值'}
//         },
//         {
//           path: 'oldtonew',
//           component: ()=> import('./views/sim/oldtonew.vue'),
//           meta: {title: '老卡转新卡'}
//         },
//         {
//           path: 'bindRecord',
//           component: ()=> import('./views/sim/bindRecord.vue'),
//           meta: {title: '绑定手机记录'}
//         },
//         {
//           path: 'bgdBatchRecharge',
//           component: ()=> import('./views/sim/bgdBatchRecharge.vue'),
//           meta: {title: '后台批量充值'}
//         }
//       ]
//     },
//     {
//       path: '/packageMgt',
//       component: layout,
//       meta: {title: '套餐管理', icon: '#se-icon-package'},
//       children: [
//         {
//           path: 'pkgGroup',
//           component: ()=> import('./views/package/pkgGroup.vue'),
//           meta: {title: '套餐组'}
//         },
//         {
//           path: 'pkgType',
//           component: ()=> import('./views/package/pkgType.vue'),
//           meta: {title: '套餐类型'}
//         },
//         {
//           path: 'pkgCategory',
//           component: ()=> import('./views/package/pkgCategory.vue'),
//           meta: {title: '套餐类别'}
//         },
//         {
//           path: 'pkgChange',
//           component: ()=> import('./views/package/pkgChange.vue'),
//           meta: {title: '套餐变更'}
//         },
//         {
//           path: 'pkgDistribut',
//           component: ()=> import('./views/package/pkgDistribut.vue'),
//           meta: {title: '套餐分销'}
//         },
//         {
//           path: 'pkgTransfer',
//           component: ()=> import('./views/package/pkgTransfer.vue'),
//           meta: {title: '套餐划拨'}
//         }
//       ]
//     },
//     {
//       path: '/csm',
//       component: layout,
//       meta: {title: '客服管理', icon: '#se-icon-customer-service'},
//       children: [
//         {
//           path: 'bindSet',
//           component: ()=> import('./views/csm/bindSet.vue'),
//           meta: {title: '手机绑定设置'}
//         },
//         {
//           path: 'changeCard',
//           component: ()=> import('./views/csm/changeCard.vue'),
//           meta: {title: '申请换卡'}
//         }
//       ]
//     },
//     {
//       path: '/financialMgt',
//       component: layout,
//       meta: {title: '财务管理', icon: '#se-icon-finance'},
//       children: [
//         {
//           path: 'myAccount',
//           component: ()=> import('./views/finance/myAccount.vue'),
//           meta: {title: '我的核算'}
//         },
//         {
//           path: 'orderSettlement',
//           component: ()=> import('./views/finance/orderSettlement.vue'),
//           meta: {title: '订单结算'}
//         },
//         {
//           path: 'bgdOrder',
//           component: ()=> import('./views/finance/bgdOrder.vue'),
//           meta: {title: '后台订单'}
//         },
//         {
//           path: 'withdrawal',
//           component: ()=> import('./views/finance/withdrawal.vue'),
//           meta: {title: '提现申请'}
//         },
//         {
//           path: 'application',
//           component: ()=> import('./views/finance/application.vue'),
//           meta: {title: '我要申请'}
//         },
//         {
//           path: 'secondReturn',
//           component: ()=> import('./views/finance/secondReturn.vue'),
//           meta: {title: '秒返订单'}
//         },
//         {
//           path: 'dayMyAccount',
//           component: ()=> import('./views/finance/dayMyAccount.vue'),
//           meta: {title: '每日我的核算'}
//         },
//         {
//           path: 'dayOrderAccount',
//           component: ()=> import('./views/finance/dayOrderAccount.vue'),
//           meta: {title: '每日订单结算'}
//         }
//       ]
//     },
//     {
//       path: '/system',
//       component: layout,
//       redirect: '/system/roleMgt',
//       meta: {title: '系统管理', icon: '#se-icon-system'},
//       children: [
//         {
//           path: 'roleMgt',
//           component: () => import('./views/system/roleMgt.vue'),
//           meta: {title: '角色管理'}
//         },
//         {
//           path: 'staffSet',
//           component: () => import('./views/system/staffSet.vue'),
//           meta: {title: '人员设置'}
//         },
//         {
//           path: 'accountMgt',
//           component: () => import('./views/system/accountMgt.vue'),
//           meta: {title: '账号管理'}
//         },
//         {
//           path: 'verified',
//           component: () => import('./views/system/verified.vue'),
//           meta: {title: '实名认证'}
//         },
//         {
//           path: 'notify',
//           component: () => import('./views/system/systemNotify.vue'),
//           meta: {title: '系统公告'}
//         },
//         {
//           path: 'myNotify',
//           component: () => import('./views/system/myNotify.vue'),
//           meta: {title: '我的公告'}
//         },
//         {
//           path: 'submitWorkOrder',
//           component: () => import('./views/system/submitWorkOrder.vue'),
//           meta: {title: '提交工单'}
//         },
//         {
//           path: 'feedback',
//           component: () => import('./views/system/feedback.vue'),
//           meta: {title: '问题反馈'}
//         },
//         {
//           path: 'workOrderMgt',
//           component: () => import('./views/system/workOrderMgt.vue'),
//           meta: {title: '工单管理'}
//         }
//       ]
//     },
//     {
//       path: '/dataMonitor',
//       component: layout,
//       meta: {title: '流量监控', icon: '#se-icon-flux-watch'},
//       children: [
//         {
//           path: 'cuccFluxMonitor',
//           component: () => import('./views/monitor/cuccFluxMonitor.vue'),
//           meta: {title: '电信流量监控'}
//         },
//         {
//           path: 'cmccFluxMonitor',
//           component: () => import('./views/monitor/cmccFluxMonitor.vue'),
//           meta: {title: '移动流量监控'}
//         }
//       ]
//     },
//     {
//       path: '/changeRecord',
//       component: layout,
//       meta: {title: '变更记录', icon: '#se-icon-change-record'},
//       children: [
//         {
//           path: 'simDeleteRecord',
//           component: ()=> import('./views/record/simDeleteRecord.vue'),
//           meta: {title: 'SIM卡删除记录'}
//         },
//         {
//           path: 'expiredChangeRecord',
//           component: ()=> import('./views/record/expiredChangeRecord.vue'),
//           meta: {title: '过期时间变更记录'}
//         },
//         {
//           path: 'downloadRecord',
//           component: ()=> import('./views/record/downloadRecord.vue'),
//           meta: {title: '下载导出记录'}
//         },
//         {
//           path: 'simDistributRecord',
//           component: ()=> import('./views/record/simDistributRecord.vue'),
//           meta: {title: 'SIM卡分销记录'}
//         },
//         {
//           path: 'simStopStartRecord',
//           component: ()=> import('./views/record/simStopStartRecord.vue'),
//           meta: {title: '停复机记录'}
//         },
//         {
//           path: 'simRecoveryRecord',
//           component: ()=> import('./views/record/simRecoveryRecord.vue'),
//           meta: {title: 'SIM卡回收记录'}
//         },
//         {
//           path: 'leicaCard',
//           component: ()=> import('./views/record/leicaCard.vue'),
//           meta: {title: '违禁记录'}
//         },
//         {
//           path: 'simCancelRecord',
//           component: ()=> import('./views/record/simCancelRecord.vue'),
//           meta: {title: 'SIM卡注销记录'}
//         },
//         {
//           path: 'pkgChangeRecord',
//           component: ()=> import('./views/record/pkgChangeRecord.vue'),
//           meta: {title: '套餐变更记录'}
//         }
//       ]
//     },
//     {
//       path: '/customerMgt',
//       component: layout,
//       meta: {title: '客户管理', icon: '#se-icon-customers'},
//       children: [
//         {
//           path: 'customerMgt',
//           component: ()=> import('./views/customers/customerMgt.vue'),
//           meta: {title: '客户管理'}
//         },
//         {
//           path: 'customerAuth',
//           component: ()=> import('./views/customers/customerAuth.vue'),
//           meta: {title: '客户权限'}
//         },
//         {
//           path: 'customerAccount',
//           component: ()=> import('./views/customers/customerAccount.vue'),
//           meta: {title: '客户账号'}
//         },
//         {
//           path: 'secondReturnSet',
//           component: ()=> import('./views/customers/secondReturnSet.vue'),
//           meta: {title: '秒返设置'}
//         }
//       ]
//     },
//     {
//       path: '/contract',
//       component: layout,
//       meta: {title: '承接业务', icon: '#se-icon-contract'},
//       children: [
//         {
//           path: 'vedioOrder',
//           component: ()=> import('./views/contract/vedioOrder.vue'),
//           meta: {title: '影视会员'}
//         }
//       ]
//     },
//     {
//       path: '/download',
//       component: layout,
//       meta: {title: '下载管理', icon: '#se-icon-contract'},
//       children: [
//         {
//           path: 'downloadArea',
//           component: ()=> import('./views/download/downloadArea.vue'),
//           meta: {title: '任务中心'}
//         }
//       ]
//     }
//   ]
// })




// export default router
